<template lang="pug">
  .flow-builder-attachment-template(:class="{editable: !disabled}")
    template-tools(v-if="!disabled", @delete="$emit('delete')")
    .template-platforms-container.badges.mb-3(v-if="disabled")
      b-badge(v-for="(platform, platform_index) in selectedPlatformsObjects.slice(0, sliceEnd)", :key="platform.platform_id", :style="{'background-color': platformColor(platform.name, 0.7)}") {{ platform.title }}
      b-badge(v-if="selectedPlatformsObjects.slice(sliceEnd).length", variant="soft-secondary") {{ selectedPlatformsObjects.slice(sliceEnd).length }} más
    .template-platforms-container.overflow-x.no-wrap.mb-3(v-else)
      b-form-group
        label.text-help.text-sm Plataformas donde se usará este template:
        k-select.disabled-white.flush(placeholder="- Agregar plataformas -", :options="parsedPlatforms", :disabled="disabled", :value="selected_platforms", @input="updatePlatforms", multiple, :limit="3", :searchable="false")
    fieldset.mb-3(:disabled="disabled")
      b-form-group(label="Tipo de archivo:", v-for="(template_attribute, template_attribute_index) in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name == 'file_type'")
        b-form-select(:value="template_attribute.value || null", @change="updateTemplateAttribute(template_attribute, $event)")
          option(:value="null", disabled) -- Selecciona tipo --
          option(v-for="attachmentType in attachment_types", :key="attachmentType.type", :value="attachmentType.type") {{ attachmentType.name }}
      b-form-group(label="URL del archivo:", v-for="(template_attribute, template_attribute_index) in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name == 'url' && !isBase64")
        b-input-group.mb-2
          b-form-input.bg-white.mb-2(placeholder="URL del archivo" v-model="fileURL" @change="updateURL")
      b-form-group(label="Nombre del archivo" v-for="template_attribute, template_attribute_index in Template_Attributes", :key="template_attribute.template_attribute_id", v-if="template_attribute.name == 'filename'" )
        b-input-group.mb-2(:append="getExtension()")
          b-form-input.bg-white(placeholder="miArchivo" v-model="filename" @change="updateFilename")
        b-form-group(v-if="isBase64" label="Data")
          b-textarea.form-control(placeholder="Descripción del archivo" v-model="base64Data" @change="filePicked")
        b-input-group(v-if='legacy.base64')
          b-form-checkbox(v-model='isBase64') Archivo en base64
      b-button(v-if="!disabled && !isBase64", variant="light", block, :disabled="loading", @click="$refs.input_attachment.click()")
          b-spinner(v-if="loading", variant="primary", type="grow")
          span(v-else) Seleccionar archivo
    input(type="file", :accept="acceptedFiles", style="display:none;", ref="input_attachment", @change="filePicked")
</template>

<script>
import ButtonCommon from '@/components/templates/common/Button.vue'
import TemplateTools from '@/components/templates/common/Tools.vue'
import Button from '@/components/templates/connectors/Button.vue'
import templateCommon from '@/helpers/template-common'
import { UploadFile } from '@/helpers/upload-file'
import { mapActions } from 'vuex'

export default {
  mixins: [templateCommon],
  data: function () {
    return {
      legacy: {
        base64: true
      },
      base64Data: '',
      isBase64: false,
      regexFile: /[^a-zA-Z0-9À-ú,\s\-_]/g,
      loading: false,
      attachment_types: [
        {
          type: 'file',
          name: 'Documento',
          accept: '.pdf,.doc,.xls,.ppt,.pptx,.xlsx,.docx,.csv'
        },
        { type: 'video', name: 'Video', accept: 'video/*' },
        { type: 'audio', name: 'Audio', accept: 'audio/*' }
      ],
      filename: '',
      fileURL: ''
    }
  },
  computed: {
    QuickReplies() {
      return this.Template_Connectors.filter(
        (connector) => connector.type === 'quick_reply'
      )
    },
    acceptedFiles() {
      const templateAttribute = this.Template_Attributes.find((attribute) => {
        return attribute.name === 'file_type'
      })

      if (templateAttribute) {
        const type = this.attachment_types.find(
          (t) => t.type === templateAttribute.value
        )
        return type ? type.accept : '*'
      }
      return '*'
    }
  },
  methods: {
    ...mapActions(['helpers/upload_file']),
    async saveBase64Data() {
      const { base64Data } = this
      const base64DataAttribute = this.Template_Attributes.find(
        (attribute) => attribute.name === 'base64Data'
      )
      if (!base64DataAttribute) return
      await this.updateTemplateAttribute(base64DataAttribute, base64Data)
    },
    async filePicked(event) {
      if (!this.filename) { return this.$message.warning('Debe ingresar un nombre para el archivo') }
      if (this.isBase64) return await this.saveBase64Data()
      const file = event.target.files[0]
      if (file.size / 1000000 >= 25) {
        this.$message.warning('El archivo no debe exceder los 25 MB')
        this.$refs.input_attachment.value = ''
        return
      }
      await this.loadFile(file)
      this.$refs.input_attachment.value = ''
    },
    checkBase64() {
      const isBase64 = this.Template_Attributes.find(
        (attribute) => attribute.name === 'isBase64'
      )
      this.legacy.base64 = false
      if (!isBase64) return false
      this.isBase64 = isBase64.value === '1'
      this.legacy.base64 = true
    },
    checkBase64Data() {
      const base64Data = this.Template_Attributes.find(
        (attribute) => attribute.name === 'base64'
      )
      if (!base64Data) return
      this.base64Data = base64Data.value || ''
    },
    getExtension() {
      try {
        const url = this.Template_Attributes.find(
          (attribute) => attribute.name === 'url'
        ).value
        const filename = this.Template_Attributes.find(
          (attribute) => attribute.name === 'filename'
        ).value
        if (!url && !filename) return ''
        if (filename) {
          return filename.includes('.') ? filename.split('.').pop() : ''
        }
        return url.split('/').pop().split('.').pop()
      } catch (e) {
        console.error(e)
        return ''
      }
    },
    async updateFilename() {
      const templateAttribute =
        this.Template_Attributes.find((attribute) => {
          return attribute.name === 'filename'
        }) || {}
      if (!this.filename) { return this.$message.warning('Debe ingresar un nombre para el archivo') }
      this.loading = true
      const haveExtension = this.filename.includes('.')
      const ext = haveExtension
        ? this.filename.split('.').pop()
        : this.getExtension()
      let parsedFilename = haveExtension
        ? this.filename.split('.').shift()
        : this.filename
      parsedFilename = parsedFilename.trim().replace(this.regexFile, '')
      let filename = parsedFilename
      if (ext) filename += `.${ext}`
      this.filename = parsedFilename
      await this.updateTemplateAttribute(templateAttribute, filename)
      this.loading = false
      this.$message.success('Nombre del archivo actualizado')
    },
    async updateURL() {
      const templateAttribute = this.Template_Attributes.find((attribute) => {
        return attribute.name === 'url'
      })
      if (!this.fileURL) { return this.$message.warning('Debe ingresar una URL para el archivo') }
      this.loading = true
      await this.updateTemplateAttribute(templateAttribute, this.fileURL)
      this.loading = false
      this.$message.success('URL del archivo actualizada')
    },
    async loadFile(file = {}) {
      try {
        this.loading = true
        const { name = '' } = file
        const fileExt = name.includes('.')
          ? name.split('.').pop()
          : this.getExtension()
        const onlyFilename = this.filename.includes('.')
          ? this.filename.split('.').shift()
          : this.filename
        const filename = onlyFilename.trim()
        const params = {
          filename,
          extension: fileExt,
          isBase64: this.isBase64,
          base64: this.base64Data
        }
        const fileUrl = await UploadFile.call(this, file, params)
        const urlAttr = this.Template_Attributes.find((attribute) => {
          return attribute.name === 'url'
        })
        const fileAttr = this.Template_Attributes.find((attribute) => {
          return attribute.name === 'filename'
        })
        const parsedFilename = filename.replace(this.regexFile, '')
        const finalFilename = parsedFilename + '.' + fileExt
        const attributes = [
          [fileAttr, finalFilename],
          [urlAttr, fileUrl]
        ]
        await Promise.all(
          attributes.map(
            async ([templateAttribute, value]) =>
              await this.updateTemplateAttribute(templateAttribute, value)
          )
        )
        this.filename = parsedFilename
        this.fileURL = fileUrl
        this.loading = false
      } catch (e) {
        this.loading = false
        console.error(e)
        this.$message.error('Error subiendo archivo. Intenta de nuevo.')
      }
    },
    async updateTemplateAttribute(templateAttribute, value) {
      const attribute = JSON.parse(JSON.stringify(templateAttribute))
      attribute.value = value

      return await this.updateAttribute(
        this.block_id,
        this.template_id,
        attribute
      )
    }
  },
  watch: {
    isBase64(value) {
      const base64Attr = this.Template_Attributes.find((attribute) => {
        return attribute.name === 'isBase64'
      })
      if (!base64Attr) return
      this.updateTemplateAttribute(base64Attr, value)
    },
    base64Data(value) {
      const base64Attr = this.Template_Attributes.find((attribute) => {
        return attribute.name === 'base64'
      })
      if (!base64Attr) return
      this.updateTemplateAttribute(base64Attr, value)
    }
  },
  components: {
    'button-connector': Button,
    ButtonCommon,
    TemplateTools
  },
  mounted() {
    const filename = this.Template_Attributes.find((attribute) => {
      return attribute.name === 'filename'
    })
    const fileUrl = this.Template_Attributes.find((attribute) => {
      return attribute.name === 'url'
    })
    this.checkBase64()
    this.checkBase64Data()
    this.filename = filename ? filename.value.split('.').shift() : ''
    this.fileURL = fileUrl ? fileUrl.value : ''
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/colors.scss';

.flow-builder-attachment-template {
  flex: 1 0 auto;
  max-width: 100%;
  background-color: transparent;
  white-space: normal;
  position: relative;

  &.editable {
    flex: 1 0 auto;
    width: 100%;
  }
}
</style>
